import * as React from "react";
import { forwardRef } from "react";
const SvgShare = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17.021, height: 16.775, viewBox: "0 0 17.021 16.775", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m12.066 0-1.045 1.045 3.171 3.172h-1.633a9.615 9.615 0 0 0-9.6 9.6h1.474A8.116 8.116 0 0 1 12.56 5.69h1.633l-3.171 3.172 1.044 1.045 4.955-4.955ZM0 4.955v11.82h16.253v-4.432h-1.477v2.955H1.478V4.955Z", className: "s2532e71440d7ff76f0fb43dfa52e484d__a" }));
const ForwardRef = forwardRef(SvgShare);
export { ForwardRef as ReactComponent };
